if (!customElements.get('product-modal')) {
	customElements.define(
		'product-modal',
		class ProductModal extends ModalDialog {
			constructor() {
				super();
			}

		hide() {
			super.hide();

			// Reset zoom when closing modal
			const allZoomContainers = this.querySelectorAll(
				'[data-main-modal-slider] .swiper-zoom-container',
			);
			allZoomContainers.forEach((container) => {
				container.style.transform = 'scale(1)';
				container.style.transformOrigin = 'center center';
			});

			const allImages = this.querySelectorAll('.swiper-zoom-target');
			allImages.forEach((img) => {
				img.style.transformOrigin = 'center center';
			});

			const mediaModals = this.querySelectorAll('.media-modal');
			mediaModals.forEach((modal) => {
				modal.classList.remove('media-modal--zoom-out');
			});

			// Show arrows
			const sliderArrowPrev = this.querySelector(
				'[data-main-modal-slider] .clrz-swiper--prev',
			);
			const sliderArrowNext = this.querySelector(
				'[data-main-modal-slider] .clrz-swiper--next',
			);
			if (sliderArrowPrev && sliderArrowNext) {
				sliderArrowPrev.style.display = 'flex';
				sliderArrowNext.style.display = 'flex';
			}

			document.querySelectorAll('video').forEach((video) => {
				video.play();
			});
		}

			show(opener) {
				super.show(opener);
				this.showActiveMedia();
			}

			showActiveMedia() {
				this.querySelectorAll(
					`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`,
				).forEach((element) => {
					element.classList.remove('active');
				});
				const activeMedia = this.querySelector(
					`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`,
				);
				const activeMediaTemplate = activeMedia.querySelector('template');
				const activeMediaContent = activeMediaTemplate
					? activeMediaTemplate.content
					: null;
				activeMedia.classList.add('active');
				activeMedia.scrollIntoView();

				const container = this.querySelector('[role="document"]');
				container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

				if (
					activeMedia.nodeName == 'DEFERRED-MEDIA' &&
					activeMediaContent &&
					activeMediaContent.querySelector('.js-youtube')
				)
					activeMedia.loadContent();
			}
		},
	);
}
